import { Context, getBroaderOrEqualContextsHierarchy, isCascading } from 'access-control/Context.enum';
import { Role } from 'lib/types/role-type';
export type EffectiveRoleResult = {
    role: Role;
    context: Context;
};

export const resolveEffectiveRole = (userRoles: Map<Context, Role>, context: Context): EffectiveRoleResult => {
    const reversedHierarchy = getBroaderOrEqualContextsHierarchy(context).reverse();
    let effectiveRole: EffectiveRoleResult | null = null;

    reversedHierarchy.forEach(contextInHierarchy => {
        if (userRoles.has(contextInHierarchy)) {
            effectiveRole = getEffectiveRole(effectiveRole, userRoles.get(contextInHierarchy)!, contextInHierarchy);
        }
    });

    if (effectiveRole === null) {
        throw Error('Effective role could not be resolved. Are you sure all user roles were passed to resolver?');
    }

    return effectiveRole;
};

const getEffectiveRole = (
    previousEffectiveRole: EffectiveRoleResult | null,
    contextRole: Role,
    context: Context,
): EffectiveRoleResult | null => {
    if (previousEffectiveRole === null) {
        return createResult(contextRole, context);
    }

    if (isCascading(context) && contextRole.cascading) {
        return createResult(contextRole, context);
    }

    return previousEffectiveRole;
};

const createResult = (role: Role, context: Context): EffectiveRoleResult => ({
    role,
    context,
});
